import { module } from 'modujs';
import { html } from '../utils/environment';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.$slides = this.$('slide');
        this.$patternsWrap = this.$('patternsWrap')[0];
        this.$patterns = this.$('pattern');
        this.$navItems = this.$('navItem');
        this.$nav = this.$('nav')[0];
        this.$wrap = this.$('wrap')[0];
    }

    init() {
        this.$slides.forEach((slide, index) => {
            if(index == 0) {
                this.setActive(slide, this.$patterns[index], this.$navItems[index], index);
            }
        })

        this.oldPattern = null;
    }

    trigger(e) {
        
        let id = e.$el.getAttribute('data-scroll-id');

        if(e.mode == 'enter') {
            this.$slides.forEach((slide, index) => {
                slide.classList.remove('is-active');
                this.$patterns[index].classList.remove('is-active');
                this.$navItems[index].classList.remove('is-active');

                if(slide.getAttribute('id') == id) {
                    this.setActive(slide, this.$patterns[index], this.$navItems[index], index);
                }
            });
        }
    }

    setActive(slide, pattern, navItem, index) {
                
        slide.classList.add('is-active');
        navItem.classList.add('is-active');

        if(this.el.getAttribute('data-slide-active') == index) {
            return;
        }

        this.el.setAttribute('data-slide-active', index);

        this.displayPattern(pattern);

        let background = slide.getAttribute('data-background');
        let foreground = slide.getAttribute('data-foreground');

        this.$wrap.style.backgroundColor = background;
        this.$nav.style.color = foreground;
        // pattern.style.backgroundColor = background;

        if(foreground == '#ffffff') {
            html.classList.add(`has-theme-light-top`);
            html.classList.add(`has-theme-light-middle`);
            html.classList.add(`has-theme-light-bottom`);

            html.classList.remove(`has-theme-dark-top`);
            html.classList.remove(`has-theme-dark-middle`);
            html.classList.remove(`has-theme-dark-bottom`);
        } else {
            html.classList.add(`has-theme-dark-top`);
            html.classList.add(`has-theme-dark-middle`);
            html.classList.add(`has-theme-dark-bottom`);

            html.classList.remove(`has-theme-light-top`);
            html.classList.remove(`has-theme-light-middle`);
            html.classList.remove(`has-theme-light-bottom`);
        }
    }

    displayPattern(pattern) {
        if(this.oldPattern != null) {
            this.oldPattern.classList.remove('is-active');
        }
        
        let clonedPattern = pattern.cloneNode(true);
        this.$patternsWrap.appendChild(clonedPattern);

        gsap.delayedCall(0.02,() => {
            clonedPattern.classList.add('is-active');
            
            if(this.oldPattern != null) {
                gsap.delayedCall(1.2,() => {
                    this.$patternsWrap.removeChild(this.oldPattern);
                    this.oldPattern = clonedPattern;
                })
            } else {
                this.oldPattern = clonedPattern;
            }
        })
    }
}
